module.exports = __webpack_public_path__ + "static/img/HT.0a7d22ff.svg";